import vClickOutside from "v-click-outside";

export default {
  inject: ["$validator"],

  props: {
    increment: { type: Number, default: 1 },
    minimum: { type: Number },
    onChange: { type: Function },
    label: { type: String },
    title: { type: String },
    disabled: { type: Boolean, default: false },
  },

  data() {
    return {
      isOpen: false,
      quantityDropdownListLength: 10,
      quantityList: [],
      selectedQuantity: null,
      isInputEditable: false,
      customQuantityInput: null,
      editableQuantityDefaultValue: null,
      computedMinimum: null,
    };
  },

  methods: {
    createQuantityList,
    toggleDropDown,
    closeDropDown,
    handleQuantitySelect,
    handleEditorOpenClick,
    handleSubmit,
    openDropDown,
    adjustCustomQuantityToMatchIncrement,
  },

  mounted() {
    // if a product min is 1 then we set start the quantity min at the incremnet
    // ex: inc: 20 min:1 then 0 = 20, not 1
    this.computedMinimum = this.minimum === 1 ? this.increment : this.minimum;
    this.selectedQuantity = this.computedMinimum;
    // send default to parent
    this.onChange(this.selectedQuantity);
    this.createQuantityList();
    this.editableQuantityDefaultValue = this.quantityList.pop();
    this.customQuantityInput = this.editableQuantityDefaultValue;
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
};
function toggleDropDown() {
  this.isOpen = !this.isOpen;
}
function openDropDown() {
  this.isOpen = true;
}
function closeDropDown() {
  this.isOpen = false;
}
function createQuantityList() {
  var a = [];
  let acc = this.computedMinimum;
  a.push(acc);
  for (var i = 0; i < this.quantityDropdownListLength; i++) {
    acc = acc + this.increment;
    a.push(acc);
  }
  this.quantityList = a;
}

function handleEditorOpenClick() {
  this.closeDropDown();
  this.isInputEditable = true;
  this.computedMinimum = this.editableQuantityDefaultValue;
  // :(  have to wait for vue to toggle so we can access dom to focus
  setTimeout(() => this.$refs.quanityEditorInput.focus(), 100);
}
function handleQuantitySelect(value) {
  this.selectedQuantity = value;
  this.isInputEditable = false;
  this.closeDropDown();
  this.onChange(this.selectedQuantity);
}
function handleSubmit() {
  this.adjustCustomQuantityToMatchIncrement();
  this.isInputEditable = false;
  this.closeDropDown();
  this.onChange(this.selectedQuantity);
}
function adjustCustomQuantityToMatchIncrement() {
  // user enters a value below the default, we revert to default
  if (this.customQuantityInput < this.editableQuantityDefaultValue) {
    this.selectedQuantity = this.editableQuantityDefaultValue;
    return;
  }
  // user enters next incremnet or default value
  if (
    this.editableQuantityDefaultValue === this.customQuantityInput ||
    this.editableQuantityDefaultValue + this.increment === this.customQuantityInput
  ) {
    this.selectedQuantity = this.customQuantityInput;
    return;
  }
  // build an array from the default value to custom input
  let a = [],
    accumulator = this.editableQuantityDefaultValue;
  while (accumulator < this.customQuantityInput) {
    accumulator = accumulator + this.increment;
    a.push(accumulator);
  }
  // get the upper and lower bounds around the custom value
  const lowerBound = a[a.length - 2] ? a[a.length - 2] : this.editableQuantityDefaultValue,
    upperBound = a[a.length - 1],
    lowerBoundDifference = this.customQuantityInput - lowerBound,
    upperBoundDifference = upperBound - this.customQuantityInput;
  // if the inputed quanity is exactly in the middle of upper and lower bound, round up
  this.customQuantityInput =
    lowerBoundDifference === upperBoundDifference
      ? upperBound
      : // otherwise round to whichever bound is closer
      lowerBoundDifference < upperBoundDifference
      ? lowerBound
      : upperBound;
  this.selectedQuantity = this.customQuantityInput;
}
